'use client'

import { useCallback, useMemo } from 'react'

import { navigateToPage } from '@marketplace-web/shared/browser-util'
// Temporary workaround. Resolve ASAP. Do not add more ignores like this.
// eslint-disable-next-line eslint-comments/no-restricted-disable
// eslint-disable-next-line @nx/enforce-module-boundaries
import { useRequest } from '@marketplace-web/shared/request'
import { toParams } from '@marketplace-web/shared/utils'

const useLocation = () => {
  const { url, serverUrl, urlParams, routerPush, back, push, replace, refreshUrl } =
    useRequest().location

  const safeBack = useCallback(
    (fallbackUrl: string) => {
      if (document.referrer.indexOf(new URL(url).origin) === -1) {
        navigateToPage(fallbackUrl)
      } else {
        back()
      }
    },
    [back, url],
  )

  const initialSearchParams = useMemo(() => toParams(new URL(serverUrl).search), [serverUrl])

  const currentUrl = useMemo(() => new URL(url), [url])
  const searchParams = useMemo(() => toParams(currentUrl.search), [currentUrl.search])

  return useMemo(
    () => ({
      href: currentUrl.href,
      baseUrl: currentUrl.origin,
      host: currentUrl.host,
      urlQuery: currentUrl.search,
      relativeUrl: currentUrl.pathname,
      urlHash: currentUrl.hash,
      searchParams,
      initialSearchParams,
      urlParams,
      safeBack,
      goToPreviousPage: back,
      pushHistoryState: push,
      routerPush,
      replaceHistoryState: replace,
      refreshUrl,
    }),
    [
      back,
      currentUrl,
      initialSearchParams,
      push,
      refreshUrl,
      replace,
      routerPush,
      safeBack,
      urlParams,
      searchParams,
    ],
  )
}

export default useLocation
